module.exports = __webpack_public_path__ + "img/b520c2e.png";